import { usePopup } from 'common/contexts/popup';
import React, { useCallback } from 'react';
import PinPrompt from './PinPrompt';

interface LockedChannelPopupProps {
  popupId: string;
  onSuccess: () => void;
  title?: string;
}

function LockedChannelPopup({
  popupId,
  onSuccess: onSuccessParam,
  title
}: LockedChannelPopupProps) {
  const { closePopup } = usePopup();
  const onSuccess = useCallback(() => {
    closePopup(popupId, onSuccessParam);
  }, [onSuccessParam, popupId]);

  const onBack = useCallback(() => {
    closePopup(popupId);
  }, []);

  return <PinPrompt onSuccess={onSuccess} onBack={onBack} lockedChannelTitle title={title} />;
}

export default React.memo(LockedChannelPopup);
